import _asyncToGenerator from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _toConsumableArray from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _regeneratorRuntime from "/vercel/path0/node_modules/@babel/runtime/regenerator/index.js";
import { chain as parseInput, chainAsync as parseInputAsync } from '../plugins/input/index.js';
import fetchId from '../util/fetchId.js';

var add = function add(data) {
  var _this$data,
      _this = this;

  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var log = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  if (options === true || log === true) {
    this.save();
  }

  (_this$data = this.data).push.apply(_this$data, _toConsumableArray(parseInput(data, options)));

  this.data.filter(function (entry) {
    return !Object.prototype.hasOwnProperty.call(entry, 'id');
  }).forEach(function (entry) {
    entry.id = fetchId(_this.getIds(), 'temp_id_');
  });
  return this;
};

var addAsync = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(data) {
    var _this$data2,
        _this2 = this;

    var options,
        log,
        _args = arguments;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            options = _args.length > 1 && _args[1] !== undefined ? _args[1] : {};
            log = _args.length > 2 && _args[2] !== undefined ? _args[2] : false;

            if (options === true || log === true) {
              this.save();
            }

            _context.t0 = (_this$data2 = this.data).push;
            _context.t1 = _this$data2;
            _context.t2 = _toConsumableArray;
            _context.next = 8;
            return parseInputAsync(data, options);

          case 8:
            _context.t3 = _context.sent;
            _context.t4 = (0, _context.t2)(_context.t3);

            _context.t0.apply.call(_context.t0, _context.t1, _context.t4);

            this.data.filter(function (entry) {
              return !Object.prototype.hasOwnProperty.call(entry, 'id');
            }).forEach(function (entry) {
              entry.id = fetchId(_this2.getIds(), 'temp_id_');
            });
            return _context.abrupt("return", this);

          case 13:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  return function addAsync(_x) {
    return _ref.apply(this, arguments);
  };
}();

var set = function set(data) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var log = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  if (options === true || log === true) {
    this.save();
  }

  this.data = [];
  return typeof options !== 'boolean' ? this.add(data, options) : this.add(data);
};

var setAsync = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(data) {
    var options,
        log,
        _args2 = arguments;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            options = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : {};
            log = _args2.length > 2 && _args2[2] !== undefined ? _args2[2] : false;

            if (options === true || log === true) {
              this.save();
            }

            this.data = [];
            return _context2.abrupt("return", typeof options !== 'boolean' ? this.addAsync(data, options) : this.addAsync(data));

          case 5:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, this);
  }));

  return function setAsync(_x2) {
    return _ref2.apply(this, arguments);
  };
}();

var reset = function reset(log) {
  if (log) {
    this.save();
  }

  this.data = [];
  this._options = {};
  return this;
};

export { add, addAsync, set, setAsync, reset };